import { CalendarEvent } from '@commenda/types/src/compliance-calendar/compliances/calendar-event';
import { NonTimezoneSensitiveDate } from '@commenda/utils';
import { CalendarDateRange, RbcEvent } from './calendar.types';

export { CATEGORY_COLOR } from './calendar.constants';

export const adaptEvents = (
  dates: Record<string, { count: number; events: CalendarEvent[] }>
): RbcEvent[] =>
  Object.values(dates)
    .flatMap(({ events }) => events)
    .map((event) => {
      const date = NonTimezoneSensitiveDate.fromISO8601String(
        event.dueDate
      ).toDate();
      return {
        id: event.id,
        title: event.title,
        start: date,
        end: date,
        allDay: true as const,
        resource: event,
      };
    });

export const dateRangeToParams = (
  range: Date[] | { start: Date; end: Date }
): CalendarDateRange => {
  const start = Array.isArray(range) ? range[0]! : range.start;
  const end = Array.isArray(range) ? range[range.length - 1]! : range.end;
  return {
    startDate: NonTimezoneSensitiveDate.fromNativeDate(start).toISO8601String(),
    endDate: NonTimezoneSensitiveDate.fromNativeDate(end).toISO8601String(),
  };
};
